import defaultImg from '@/assets/images/nimg238Bg.jpg'

import Message from './Message'
const importFn = require.context('./', false, /\.vue$/)

export default {
  install (app) {
    importFn.keys().forEach(key => {
      const component = importFn(key).default
      app.component(component.name, component)
    })

    defineDirective(app)

    app.config.globalProperties.$message = Message
  }
}

const defineDirective = (app) => {
  app.directive('lazy', {
    mounted (el, binding) {
      const observe = new IntersectionObserver(([{ isIntersecting }]) => {
        if (isIntersecting) {
          // 停止观察
          observe.unobserve(el)
          el.onerror = () => {
            // 加载失败，设置默认图
            el.src = defaultImg
          }
          el.src = binding.value
        }
      }, {
        threshold: 0
      })
      // 开启观察
      observe.observe(el)
    }
  })
}
